import { SET_TREATMENT_CATEGORIES } from './treatment-categories.actions';

const initialState = [];

export const treatmentCategoriesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_TREATMENT_CATEGORIES:
      return [...payload];
    default:
      return state;
  }
};
